import { useParams, useNavigate } from "react-router-dom";
import { useState } from "react";
import { getDatabase, ref, push } from "firebase/database";

const FormularioPage = () => {
  const { vendedorId } = useParams();
  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [whatsapp, setWhatsapp] = useState("");
  const [especialidade, setEspecialidade] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (e: React.FormEvent) => {
    // e.preventDefault();

    // const db = getDatabase();
    // push(ref(db, "inscricoes"), {
    //   nome,
    //   email,
    //   whatsapp,
    //   especialidade,
    //   vendedorId,
    //   criadoEm: new Date().toISOString()
    // });

    // alert("Inscrição enviada com sucesso!");

    // // Limpar campos após envio
    // setNome("");
    // setEmail("");
    // setWhatsapp("");
    // setEspecialidade("");
    window.open("https://pag.getnet.com.br/ikA72LZsW");
  };

  return (
    <div className="flex flex-col bg-[#f5f5f5] md:h-screen">
      <div
        className="responsive-bg lg:h-screen md:h-screen flex flex-col md:flex-row-reverse lg:flex-row-reverse w-full"
        style={{
          backgroundImage: `url('https://nexxmed.com.br/wp-content/uploads/2025/05/Background-Mobile.png')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <style>
          {`
            @media (min-width: 768px) {
              div.responsive-bg {
                background-image: url('https://nexxmed.com.br/wp-content/uploads/2025/05/Background.png') !important;
              }
            }
          `}
        </style>

        <div className="p-5">
          <img
            src="https://nexxmed.com.br/wp-content/uploads/2025/05/Especialistas-1.png"
            alt="Especialistas"
            className="w-full h-auto"
          />
        </div>

        <div className="flex flex-col p-4 items-center justify-center text-center md:items-start lg:items-start md:pl-16 lg:pl-16 md:w-[100%] lg:w-[80%]">
          <div className="-mt-14 mb-3 flex items-center justify-center md:justify-start lg:justify-start md:mt-16 lg:mt-8 md:mb-8 lg:mb-8">
            <img src="https://nexxmed.com.br/wp-content/uploads/2024/09/logo_nexxmed.png" alt="" className="w-[50%]" />
          </div>

          <div className="flex flex-col items-center justify-center text-center md:text-start lg:text-start md:items-start lg:items-start md:w-[80%] lg:w-[80%]">
            <p className="text-[#ea5c35] font-bold text-xl mb-3 md:mb-8 lg:mb-8 lg:text-2xl">Curso UBE Academy Nexxmed</p>
            <p className="text-[#42525d] font-semibold text-3xl mb-3 md:mb-8 lg:mb-8 md:text-3xl lg:text-3xl">
              Preencha os campos abaixo para se inscrever no Curso Endoscopia Biportal com prática em cadáver fresh frozen
            </p>

            <form onSubmit={handleSubmit} className="w-full">
              <input
                type="text"
                placeholder="Digite o seu nome completo"
                value={nome}
                onChange={(e) => setNome(e.target.value)}
                className="rounded-full p-4 mb-4 w-full shadow-sm focus:outline-none"
                required
              />

              <input
                type="number"
                placeholder="Digite o seu WhatsApp"
                value={whatsapp}
                onChange={(e) => setWhatsapp(e.target.value)}
                className="rounded-full p-4 mb-4 w-full shadow-sm focus:outline-none"
                required
              />

              <input
                type="email"
                placeholder="Digite o seu melhor e-mail"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="rounded-full p-4 mb-4 w-full shadow-sm focus:outline-none"
                required
              />

              <div className="mb-4">
                <select
                  id="especialidade"
                  name="especialidade"
                  value={especialidade}
                  onChange={(e) => setEspecialidade(e.target.value)}
                  className="block w-full rounded-full shadow-sm py-4 px-4 focus:outline-none text-gray-500"
                  required
                >
                  <option value="">Qual a sua especialidade?</option>
                  <option value="neurocirurgiao">Neurocirurgião</option>
                  <option value="ortopedista">Ortopedista</option>
                  <option value="outro">Outro</option>
                </select>
              </div>

              <button
                type="submit"
                className="flex items-center justify-center text-center text-white bg-gradient-to-r from-[#ea5c35] to-[#f4b743] px-8 py-4 rounded-full font-bold w-full"
              >
                inscreva-se agora
              </button>

              <p className="text-sm md:text-xs text-gray-500 my-5">
                De acordo com as Leis 12.965/2014 e 13.709/2018, que regulam o uso da Internet e o tratamento de dados pessoais no Brasil,
                autorizo a Nexxmed a enviar notificações por e-mail ou outros meios e concordo com sua política de Privacidade.
              </p>
            </form>
          </div>
        </div>
      </div>

      <div className="flex flex-col bg-[#242d33] text-white justify-center items-center text-center py-16 px-4">
        <img src="https://nexxmed.com.br/wp-content/uploads/2024/09/logo_nexxmed_2-1.png" alt="" className="w-[50%] md:w-[20%] mb-8" />
        <p className="mb-5">Copyright 2025 ©️ Nexxmed - Todos os direitos reservados</p>
        <p className="text-sm font-thin">Desenvolvido por <a href="https://maincode.dev">MainCode Software</a></p>
      </div>
    </div>
  );
};

export default FormularioPage;
